<script setup lang="ts">
const props = defineProps({
  canAdd: { type: Boolean, required: false, default: false },
  disableAdd: { type: Boolean, required: false, default: false },
  disableImport: { type: Boolean, required: false, default: false }
})

const emit = defineEmits(['addItem', 'importItem'])
</script>

<template>
  <v-card-title class="px-0 header-font">
    Vessel
    <v-btn
      v-if="canAdd"
      :disabled="disableAdd"
      class="text-none mb-1 mx-1"
      color="primary"
      variant="flat"
      prepend-icon="mdi-plus"
      @click.stop="emit('importItem')"
    >
      Import from SHIP
    </v-btn>
    <v-btn
      v-if="canAdd"
      :disabled="disableImport"
      class="text-none mb-1 mx-1"
      color="primary"
      variant="flat"
      prepend-icon="mdi-plus"
      @click.stop="emit('addItem')"
    >
      Add new vessel
    </v-btn>
  </v-card-title>
</template>

<style scoped></style>
